import script from "./ProductColorsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductColorsModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProductColorsModal.vue?vue&type=style&index=0&id=2ec5f255&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec5f255"]])

export default __exports__